import { getAuthHeaders } from './auth-headers';
import { SUPABASE_FUNCTIONS_URL } from './config';

export type OverviewLatest = {
  period: string;
  hour_ts: string;
  active_accounts: number | null;
  accounts_with_data: number | null;
  total_reach: number | null;
  total_views: number | null;
  total_interactions: number | null;
  total_followers: number | null;
  avg_er: number | null;
  top_accounts: { username: string; reach: number; views: number }[] | null;
};

export type OverviewHistoryPoint = {
  hour_ts: string;
  total_reach: number | null;
  total_views: number | null;
  total_interactions: number | null;
  total_followers: number | null;
};

export async function fetchOverview(period: 'month' | 'rolling30'): Promise<{ latest: OverviewLatest | null; history: OverviewHistoryPoint[] }> {
  const headers = await getAuthHeaders();
  const res = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/overview?period=${period}`, { headers });
  if (!res.ok) throw new Error(`overview: HTTP ${res.status}`);
  return res.json();
}

// Живой пересчёт по кнопке «Обновить» (тянет свежее из Instagram).
export async function refreshOverview(period: 'month' | 'rolling30'): Promise<{ latest: OverviewLatest | null }> {
  const headers = await getAuthHeaders();
  const res = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/overview-refresh?period=${period}`, { method: 'POST', headers });
  if (!res.ok) throw new Error(`overview-refresh: HTTP ${res.status}`);
  return res.json();
}

// Живой снимок одного аккаунта по кнопке «Обновить».
export async function refreshAccount(accountId: string): Promise<void> {
  const headers = await getAuthHeaders();
  const res = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/account-refresh?accountId=${encodeURIComponent(accountId)}`, { method: 'POST', headers });
  if (!res.ok) throw new Error(`account-refresh: HTTP ${res.status}`);
}
